<div class="card mb-3">
    <div class="card-body">
        <div class="card-title h2">Facilities: Request Event Support</div>
    </div>
</div>

@if( context$ | async; as context){
    @if(!!context.person && !!context.settings){
        <div class="card mb-3">
            <div class="card-body">
                <p class="card-title"><strong>Requester Details</strong></p>
                <p class="card-text">{{context.person.displayName}}</p>
                <text-input [(obj)]="newEvent" prop="additionalContact"
                            label="Additional Contact" [labelCols]="labelColsSm" [labelColsMd]="labelColsMd" [labelColsLg]="labelColsLg"
                            [typeaheadList$]="peopleService.personTypeaheadList$ | typeaheadBinder : peopleService"
                            [requireTypeaheadSelection]="true"></text-input>
            </div>
        </div>
        
        <div class="card mb-3">
            <div class="card-body">
                <p class="card-title"><strong>Event Details</strong></p>
                
                <!--  DETAILS  -->
                <div class="card mb-3">
                    <div class="card-body">
                        <text-input [(obj)]="newEvent" prop="title"
                                    label="Event Title" [labelCols]="labelColsSm" [labelColsMd]="labelColsMd" [labelColsLg]="labelColsLg"></text-input>
                        
                        <text-input [(obj)]="newEvent" prop="description"
                                    label="Description" [labelCols]="labelColsSm" [labelColsMd]="labelColsMd" [labelColsLg]="labelColsLg"
                                    placeholder="I need 4 tables at the front, 2 for panel, 2 for handouts..."
                                    [mode]="inputMode.TextArea"></text-input>
                        
                        <text-input [(obj)]="newEvent" prop="location"
                                    label="Location" [labelCols]="labelColsSm" [labelColsMd]="labelColsMd" [labelColsLg]="labelColsLg"></text-input>
                    </div>
                </div>
                
                <!--  BUILDING  -->
                <div class="card mb-3">
                    <div class="card-body">
                        <p class="card-title"><strong>Building</strong></p>
                        <boolean-slider [(obj)]="newEvent" prop="inBell"
                                        label="Bell Hall" [labelCols]="labelColsSm" [labelColsMd]="labelColsMd" [labelColsLg]="labelColsLg"
                                        trueLabel="Yes" falseLabel="No"></boolean-slider>
                        
                        <boolean-slider [(obj)]="newEvent" prop="inCharlotte"
                                        label="Charlotte" [labelCols]="labelColsSm" [labelColsMd]="labelColsMd" [labelColsLg]="labelColsLg"
                                        trueLabel="Yes" falseLabel="No"></boolean-slider>
                        
                        <boolean-slider [(obj)]="newEvent" prop="inKenan"
                                        label="Kenan Center" [labelCols]="labelColsSm" [labelColsMd]="labelColsMd" [labelColsLg]="labelColsLg"
                                        trueLabel="Yes" falseLabel="No"></boolean-slider>
                        
                        <boolean-slider [(obj)]="newEvent" prop="inKoury"
                                        label="Koury" [labelCols]="labelColsSm" [labelColsMd]="labelColsMd" [labelColsLg]="labelColsLg"
                                        trueLabel="Yes" falseLabel="No"></boolean-slider>
                        
                        <boolean-slider [(obj)]="newEvent" prop="inMcColl"
                                        label="McColl Building" [labelCols]="labelColsSm" [labelColsMd]="labelColsMd" [labelColsLg]="labelColsLg"
                                        trueLabel="Yes" falseLabel="No"></boolean-slider>
                        
                        <observable-errors-warnings [obj]="newEvent" [props]="['building']" [useSingleAlert]="true"></observable-errors-warnings>
                    </div>
                </div>
                
                <!--  DATES  -->
                <div class="row row-cols-1 row-cols-md-2 mb-3">
                    <div class="col">
                        <div class="card h-100">
                            <div class="card-body">
                                <p class="card-title"><strong>Start Date and Time</strong></p>
                                <date-time [(obj)]="newEvent" prop="startDate"
                                           label="Start" [labelCols]="0"
                                           min="{{now}}" max="{{(now.getFullYear() + 2)}}-12-31T23:59:00"
                                           placeholder="Select a date"
                                           [allowTime]="true"></date-time>
                            </div>
                            <div class="card-footer">
                                <p>Please ensure all applicable <strong>setup and breakdown time</strong> is included in this timeframe.</p>
                            </div>
                        </div>
                    </div>
                    
                    <div class="col">
                        <div class="card h-100">
                            <div class="card-body">
                                <p class="card-title"><strong>End Date and Time</strong></p>
                                <date-time [(obj)]="newEvent" prop="endDate"
                                           label="End" [labelCols]="0"
                                           min="{{now}}" max="{{(now.getFullYear() + 2)}}-12-31T23:59:00"
                                           placeholder="Select a date"
                                           [allowTime]="true"></date-time>
                            </div>
                            <div class="card-footer">
                                <p>Please ensure all applicable <strong>setup and breakdown time</strong> is included in this timeframe.</p>
                            </div>
                        </div>
                    </div>
                </div>
                
                <!--  REQUIREMENTS  -->
                <div class="card">
                    <div class="card-body">
                        <p class="card-title"><strong>Requirements</strong></p>
                        <boolean-slider [(obj)]="newEvent" prop="includesHelp"
                                        label="I need help reserving a space" [labelCols]="labelColsSm" [labelColsMd]="labelColsMd + 2" [labelColsLg]="labelColsLg + 2"
                                        trueLabel="Yes" falseLabel="No"></boolean-slider>
                        
                        <div [class.grouped-details]="newEvent.includesCatering">
                            <boolean-slider [(obj)]="newEvent" prop="includesCatering"
                                            label="Will you be providing food?" [labelCols]="labelColsSm" [labelColsMd]="labelColsMd + 2" [labelColsLg]="labelColsLg + 2"
                                            trueLabel="Yes" falseLabel="No"></boolean-slider>
                            @if(newEvent.includesCatering){
                                <div class="p-2">
                                    <text-input [(obj)]="newEvent" prop="cateringDescription"
                                                label="Please provide details about the vendor, arrival time, etc."
                                                [labelCols]="12" [labelColsMd]="4"
                                                [mode]="inputMode.TextArea"></text-input>
                                </div>
                            }
                        </div>
                        
                        <div [class.grouped-details]="newEvent.includesAv">
                            <boolean-slider [(obj)]="newEvent" prop="includesAv"
                                            label="Audio/Visual" [labelCols]="labelColsSm" [labelColsMd]="labelColsMd + 2" [labelColsLg]="labelColsLg + 2"
                                            trueLabel="Yes" falseLabel="No"></boolean-slider>
                            @if(newEvent.includesAv){
                                @if(newEvent.inCharlotte){
                                    <div class="alert alert-danger">
                                        <strong>{{context.settings.AudioVisualCharlotteMessage}}</strong>
                                    </div>
                                }
                                <div class="alert alert-info py-2">
                                    Is this A/V request for a rental of Maynard Forum and/or Callinicos Forum?
                                </div>
                                
                                <boolean-slider [(obj)]="newEvent" prop="isRental"
                                                label="Rental" [labelCols]="12" [labelColsMd]="4"
                                                trueLabel="Yes" falseLabel="No"></boolean-slider>
                            }
                        </div>
                        
                        <boolean-slider [(obj)]="newEvent" prop="includesAventri"
                                        label="Aventri/Stova" [labelCols]="labelColsSm" [labelColsMd]="labelColsMd  + 2" [labelColsLg]="labelColsLg + 2"
                                        trueLabel="Yes" falseLabel="No"></boolean-slider>
                        
                        <boolean-slider [(obj)]="newEvent" prop="includesHousekeeping"
                                        label="Housekeeping" [labelCols]="labelColsSm" [labelColsMd]="labelColsMd  + 2" [labelColsLg]="labelColsLg + 2"
                                        trueLabel="Yes" falseLabel="No"></boolean-slider>
                        
                        <div [class.grouped-details]="newEvent.includesTent">
                            <boolean-slider [(obj)]="newEvent" prop="includesTent"
                                            label="Are you ordering a tent?" [labelCols]="labelColsSm" [labelColsMd]="labelColsMd  + 2" [labelColsLg]="labelColsLg + 2"
                                            trueLabel="Yes" falseLabel="No"></boolean-slider>
                            @if(newEvent.includesTent){
                                <text-input [(obj)]="newEvent" prop="tentDescription"
                                            label="Please provide additional details on size, placement, and setup/breakdown."
                                            [labelCols]="12" [labelColsMd]="4"
                                            [mode]="inputMode.TextArea"></text-input>
                            }
                        </div>
                        
                        <div [class.grouped-details]="newEvent.includesFurniture">
                            <boolean-slider [(obj)]="newEvent" prop="includesFurniture"
                                            label="Table and Chairs" [labelCols]="labelColsSm" [labelColsMd]="labelColsMd  + 2" [labelColsLg]="labelColsLg + 2"
                                            trueLabel="Yes" falseLabel="No"></boolean-slider>
                            @if(newEvent.includesFurniture){
                                <text-input [(obj)]="newEvent" prop="tableCount"
                                            label="Number of Tables" [labelCols]="12" [labelColsMd]="4"
                                            [mode]="inputMode.Number"
                                            (value$)="testNumber($event, 'tableCount')"></text-input>
                                
                                <text-input [(obj)]="newEvent" prop="chairCount"
                                            label="Number of Chairs" [labelCols]="12" [labelColsMd]="4"
                                            [mode]="inputMode.Number"
                                            (value$)="testNumber($event, 'chairCount')"></text-input>
                                
                                <observable-errors-warnings [obj]="newEvent" [props]="['furniture']" [useSingleAlert]="true"></observable-errors-warnings>
                            }
                        </div>
                        
                        <div [class.grouped-details]="newEvent.includesTrash">
                            <boolean-slider [(obj)]="newEvent" prop="includesTrash"
                                            label="Trash Cans" [labelCols]="labelColsSm" [labelColsMd]="labelColsMd  + 2" [labelColsLg]="labelColsLg + 2"
                                            trueLabel="Yes" falseLabel="No"></boolean-slider>
                            @if(newEvent.includesTrash){
                                <text-input [(obj)]="newEvent" prop="trashCanCount"
                                            label="Number of Trash Cans" [labelCols]="12" [labelColsMd]="4"
                                            [mode]="inputMode.Number"
                                            (value$)="testNumber($event, 'trashCanCount')"></text-input>
                            }
                        </div>
                        
                        <observable-errors-warnings [obj]="newEvent" [props]="['requirements']" [useSingleAlert]="true"></observable-errors-warnings>
                    </div>
                </div>
            </div>
        </div>
        
        <!--  BUTTONS  -->
        <div class="row form-group">
            <div class="col-sm-12">
                <button class="btn btn-primary" type="submit" (click)="submit()" [disabled]="newEvent.hasErrors || isWaiting">
                    Submit @if (isWaiting) {
                        <span><i class="fas fa-circle-notch fa-spin"></i></span>
                    }
                </button>
                
                <button class="btn btn-outline-secondary ms-2" type="button" (click)="close()" [disabled]="isWaiting">
                    Cancel
                </button>
            </div>
        </div>
        @if(response$ | async){}
    }
    @else{
        <!--  MISSING DATA  -->
        There was an issue loading this form.  Please contact <a href="mailto:AppDevSupport@kenan-flagler.unc.edu">AppDevSupport@kenan-flagler.unc.edu</a> for assistance.
    }
}
@else{
    <!--  LOADING  -->
    <div class="widget-action-loading text-center">
        <div class="typing">
            <span class="dot"></span>
            <span class="dot"></span>
            <span class="dot"></span>
        </div>
    </div>
}
